import React, { useState } from 'react';
import { Line, Bar, Pie, Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Chart.js bileşenlerini kaydedelim
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend);

function AHome() {
    // Günün saatine göre selam
    const getGreeting = () => {
        const hours = new Date().getHours();
        if (hours < 12) return "Günaydın 🌅";
        if (hours < 18) return "İyi Günler ☀️";
        return "İyi Akşamlar 🌙";
    };

    const currentTime = new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

    // Tab menü için state
    const [activeTab, setActiveTab] = useState('sales'); // Default olarak Satışlar

    // Örnek grafik verileri
    const chartData = {
        sales: {
            labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran'],
            datasets: [
                {
                    label: 'Aylık Satışlar',
                    data: [1200, 1900, 3000, 5000, 2400, 3400],
                    borderColor: 'rgba(75,192,192,1)',
                    backgroundColor: 'rgba(75,192,192,0.2)',
                },
            ],
        },
        users: {
            labels: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'],
            datasets: [
                {
                    label: 'Haftalık Kullanıcılar',
                    data: [200, 400, 350, 500, 600],
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderWidth: 1,
                },
            ],
        },
        performance: {
            labels: ['Hız', 'Verimlilik', 'Güvenilirlik'],
            datasets: [
                {
                    label: 'Sistem Performansı',
                    data: [85, 90, 78],
                    backgroundColor: 'rgba(54,162,235,0.2)',
                    borderColor: 'rgba(54,162,235,1)',
                    borderWidth: 1,
                },
            ],
        },
        pie: {
            labels: ['Kırmızı', 'Mavi', 'Yeşil'],
            datasets: [
                {
                    label: 'Dağılım',
                    data: [300, 500, 200],
                    backgroundColor: ['rgba(255,99,132,0.6)', 'rgba(54,162,235,0.6)', 'rgba(75,192,192,0.6)'],
                },
            ],
        },
        doughnut: {
            labels: ['Tamamlandı', 'Beklemede', 'Hatalı'],
            datasets: [
                {
                    label: 'Görev Durumu',
                    data: [50, 30, 20],
                    backgroundColor: ['rgba(75,192,192,0.7)', 'rgba(255,206,86,0.7)', 'rgba(255,99,132,0.7)'],
                },
            ],
        },
    };


    
    return (
        <div className="bg-sky-100 min-h-screen p-6 rounded shadow" style={{
            marginBottom:20 
        }}>
            {/* Selamlama */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
  {/* Selamlama Kartı */}
  <div className="bg-white p-3 rounded shadow">
    <h1 className="text-4xl font-bold text-gray-800">{getGreeting()}</h1>
    <p className="text-xl text-gray-600 mt-2">Saat: {currentTime}</p>
  </div>

  {/* Gelir Kartı */}
  <div className="bg-white p-6 rounded shadow">
    {/* Başlık */}
    <div className="mb-2">
      <h2 className="text-sm font-medium text-gray-600">Revenue</h2>
    </div>

    {/* Ana İçerik */}
    <div className="flex items-center space-x-4">
      {/* Gelir Miktarı */}
      <div className="flex items-baseline">
        <span className="text-4xl font-bold text-gray-900">$528,976</span>
        <span className="text-2xl font-light text-gray-500">.82</span>
      </div>

      {/* Yüzde Değişim ve Miktar */}
      <div className="flex items-center space-x-2">
        <div className="flex items-center bg-red-100 text-red-600 text-sm font-medium px-2 py-1 rounded-full">
          <span>↓</span>
          <span className="ml-1">7.9%</span>
        </div>
      </div>
    </div>

    {/* Alt Bilgi */}
    <div className="mt-2 text-sm text-gray-500">
      vs prev. $501,641.73 <span className="text-gray-400">Jun 1 - Aug 31, 2023</span>
    </div>
  </div>

  {/* Sol Kart (Top Sales) */}
  <div className="bg-white p-3 rounded shadow">
    <div className="text-sm font-medium text-gray-500">Top sales</div>
    <div className="mt-2 text-2xl font-bold text-gray-900">72</div>
    <div className="flex items-center justify-between mt-4">
      <div className="flex items-center space-x-2">
        <img
          src="https://via.placeholder.com/24"
          alt="Mikasa"
          className="w-6 h-6 rounded-full"
        />
        <span className="text-sm font-medium text-gray-700">Mikasa</span>
      </div>
      <div className="text-gray-400">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
      </div>
    </div>
  </div>

  {/* Sağ Kart (Best Deal) */}
  <div className="bg-black p-3 rounded shadow text-white">
    <div className="text-sm font-medium text-gray-400">Best deal</div>
    <div className="mt-2 text-2xl font-bold">$42,300</div>
    <div className="flex items-center justify-between mt-4">
      <div className="flex items-center space-x-2">
        <span className="text-sm font-medium text-gray-400">Rolf Inc.</span>
      </div>
      <div className="text-gray-400">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
      </div>
    </div>
  </div>
</div>

<div className="flex flex-row items-center gap-5">

<div>
  <div>
    <span className="text-sm text-gray-900">Diyecek hiçbir şey yok. yaşanır biter sen aksini istesen de. her şekilde mazeretim var psikopatım ben. mazeretim var. dengesizim ben. memleketsizim. </span>
  </div>
</div>


  <div className="bg-gray-200 rounded-xl shadow mb-4 px-2 py-2 w-full max-w-5xl mt-4 overflow-x-scroll scrollbar-none">
    <div className="flex gap-4 w-max">
      {Array(12)
        .fill("")
        .map((_, index) => (
          <div
            key={index}
            className="flex items-center bg-white shadow rounded-xl px-4 py-1 min-w-[150px]"
          >
            <div className="ml-3">
              <span className="block text-xs font-medium text-gray-800">
                Çivi çıktı. manzaralar yakışıksız. tarafını seç sen, bir an evvel. 
              </span>
            </div>
          </div>
        ))}
    </div>
  </div>
  
</div>
  





{/* Grid Sistemi */}
<div className="grid grid-cols-1 md:grid-cols-6 gap-4">
  {/* Büyük Grafik */}
  <div className="col-span-6 md:col-span-3 bg-white shadow-lg rounded-lg p-6">
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-lg font-semibold text-gray-700">
        {activeTab === 'sales'
          ? 'Aylık Satış Grafiği'
          : activeTab === 'users'
          ? 'Haftalık Kullanıcı Grafiği'
          : 'Sistem Performansı'}
      </h2>
      <div className="flex flex-wrap gap-2 justify-center">
        <button
          onClick={() => setActiveTab('sales')}
          className={`flex-1 py-1 sm:py-2 px-2 sm:px-4 text-center text-sm sm:text-base rounded ${
            activeTab === 'sales' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
          }`}
        >
          Satışlar
        </button>
        <button
          onClick={() => setActiveTab('users')}
          className={`flex-1 py-1 sm:py-2 px-2 sm:px-4 text-center text-sm sm:text-base rounded ${
            activeTab === 'users' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
          }`}
        >
          Kullanıcılar
        </button>
        <button
          onClick={() => setActiveTab('performance')}
          className={`flex-1 py-1 sm:py-2 px-2 sm:px-4 text-center text-sm sm:text-base rounded ${
            activeTab === 'performance' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
          }`}
        >
          Performans
        </button>
      </div>
    </div>
    <div className="h-80">
      {activeTab === 'sales' && (
        <Line data={chartData.sales} options={{ responsive: true, maintainAspectRatio: false }} />
      )}
      {activeTab === 'users' && (
        <Bar data={chartData.users} options={{ responsive: true, maintainAspectRatio: false }} />
      )}
      {activeTab === 'performance' && (
        <Bar data={chartData.performance} options={{ responsive: true, maintainAspectRatio: false }} />
      )}
    </div>
  </div>

  {/* Küçük Divler */}
  <div className="col-span-6 md:col-span-3 bg-white shadow-lg rounded-lg p-6">
    <h3 className="text-gray-700 font-semibold text-center mb-4">Pie Grafiği</h3>
    <div className="w-full h-80">
      <Pie
        data={chartData.pie}
        options={{
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </div>
  </div>
  <div className="col-span-6 md:col-span-3 bg-white shadow-lg rounded-lg p-6">
    <h3 className="text-gray-700 font-semibold text-center mb-4">Doughnut Grafiği</h3>
    <div className="w-full h-80">
      <Doughnut
        data={chartData.doughnut}
        options={{
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </div>
  </div>
  <div className="col-span-6 md:col-span-3 bg-white shadow-lg rounded-lg p-6">
    <h3 className="text-gray-700 font-semibold text-center mb-4">Doughnut Grafiği</h3>
    <div className="w-full h-80">
      <Doughnut
        data={chartData.doughnut}
        options={{
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </div>
  </div>
  {/* 25-25-50 Düzeni */}
  <div className="grid grid-cols-3 gap-4 col-span-6">
    {/* İlk Kart - %25 */}
    <div className="col-span-3 md:col-span-1 bg-white shadow-lg rounded-lg p-6">
      <div className="flex flex-col space-y-4">
        <div className="flex justify-between items-center">
          <button className="text-gray-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 5.25h16.5M3.75 12h16.5M3.75 18.75h16.5"
              />
            </svg>
          </button>
          <button className="flex items-center text-gray-600 space-x-1">
            <span>Filters</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 6h3m-7.5 6h12m-9 6h6"
              />
            </svg>
          </button>
        </div>
        <div className="space-y-3">
          {[
            { icon: "🌐", name: "Dribbble", amount: "$227,459", percentage: "43%" },
            { icon: "📸", name: "Instagram", amount: "$142,823", percentage: "27%" },
            { icon: "🎨", name: "Behance", amount: "$89,935", percentage: "11%" },
            { icon: "🔍", name: "Google", amount: "$37,028", percentage: "7%" },
          ].map((item, index) => (
            <div key={index} className="flex items-center justify-between p-3">
              <div className="flex items-center space-x-3">
                <span className="text-lg">{item.icon}</span>
                <span className="text-gray-700 font-medium">{item.name}</span>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-gray-700 font-bold">{item.amount}</span>
                <span className="text-gray-500 text-sm">{item.percentage}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* İkinci Kart - %25 */}
    <div className="col-span-3 md:col-span-1 bg-white shadow-lg rounded-lg p-6">İkinci Kart - %25</div>

    {/* Üçüncü Kart - %50 */}
    <div className="col-span-3 md:col-span-1 bg-white shadow-lg rounded-lg p-6">Üçüncü Kart - %50</div>
  </div>
</div>

            
        </div>
    );
}

export default AHome;
